"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPathAny = exports.canWalkTile = exports.findPath = exports.EDivePathToMode = void 0;
var astarInterface_sidecar_1 = require("@astar/astarInterface-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
// import { voyageTilemap } from '@voyage/tilemap/voyageTilemap-sidecar'
// import type { IVoyageTilemapPart } from '@voyage/tilemap/voyageTilemapPart'
var EDivePathToMode;
(function (EDivePathToMode) {
    EDivePathToMode[EDivePathToMode["On"] = 1] = "On";
    EDivePathToMode[EDivePathToMode["NextTo"] = 2] = "NextTo";
    EDivePathToMode[EDivePathToMode["OnOrNextTo"] = 3] = "OnOrNextTo";
    EDivePathToMode[EDivePathToMode["OnOrNextTo_PreferOn"] = 4] = "OnOrNextTo_PreferOn";
})(EDivePathToMode = exports.EDivePathToMode || (exports.EDivePathToMode = {}));
// const hash = (node: IDiveTilemapPart) => {
//   return node.i + ':' + node.j
// }
// const canMoveOnBreach = false
// const canMoveOnFire = false
var findPath = function (start, end, mode) {
    // if (allowNextTo) {
    //   assert.
    //   // return findPathAny(grid, start, [end])
    // }
    // This is kinda expensive... we can optimize this later
    if (mode === EDivePathToMode.OnOrNextTo_PreferOn) {
        // First try to find a path to the end
        var result = exports.findPath(start, end, EDivePathToMode.On);
        if (result.isSuccess) {
            return result;
        }
        result = exports.findPath(start, end, EDivePathToMode.NextTo);
        return result;
    }
    var ends = [];
    var allowOn = mode === EDivePathToMode.OnOrNextTo || mode === EDivePathToMode.On;
    if (allowOn) {
        ends.push(end);
    }
    var allowNextTo = mode === EDivePathToMode.OnOrNextTo || mode === EDivePathToMode.NextTo;
    if (allowNextTo) {
        // Collect valid next to spots
        checkAndCollectNeighbor(end, -1, 0, ends);
        checkAndCollectNeighbor(end, 1, 0, ends);
        checkAndCollectNeighbor(end, 0, -1, ends);
        checkAndCollectNeighbor(end, 0, 1, ends);
    }
    // console.log('looking for path', start, ends, mode)
    return exports.findPathAny(start, ends, mode);
};
exports.findPath = findPath;
var canWalkTile = function (tn) {
    if (!tn) {
        return false;
    }
    if (!tn.tile1.canWalk) {
        return false;
    }
    // See if there is an object here?
    // TODO: optimize this by adding a link to the object in the tilemap, as well as a spider to ensure integrity
    for (var iObject = 0; iObject < tn.objects.length; iObject++) {
        var obj = tn.objects[iObject];
        if (!diveObjects_sidecar_1.diveObjects.isWalkable(obj)) {
            return false;
        }
    }
    // TODO: check for monsters and don't walk through them?
    // if (tn.breach && !canMoveOnBreach) {
    //   skip = true
    // }
    // if (tn.fire && !canMoveOnFire) {
    //   skip = true
    // }
    // TODO: can't move to where there's already a unit
    // if (tn.crew.length > 0) {
    //   skip = true
    // }
    // Can only go down on ladders
    // if (!skip && oj === 1) {
    //   if (tn.type !== TypeLadder) {
    //     skip = true
    //   }
    // }
    return true;
};
exports.canWalkTile = canWalkTile;
var checkAndCollectNeighbor = function (node, oi, oj, neighbors) {
    var tn = diveTilemap_sidecar_1.diveTilemap.getSafe(node.i + oi, node.j + oj);
    if (tn && exports.canWalkTile(tn)) {
        neighbors.push(tn);
    }
};
var findPathAny = function (start, ends, mode) {
    if (ends.length === 0) {
        console.warn('no end for pathfinding');
        return {
            isSuccess: false,
            isTimeout: false,
            path: [],
        };
    }
    var isOne = ends.length === 1;
    var endOne = ends[0];
    // const heightPenalty = 1
    // const elevatorPenalty = 5
    var crewPathfindPenalty = 7;
    var deadCrewPathfindPenalty = 3;
    var distance = function (a, b) {
        var dx = Math.abs(a.i - b.i);
        var dy = Math.abs(a.j - b.j);
        var h = dx + dy; // * heightPenalty
        return h;
    };
    var heuristicOne = function (node) {
        var end = endOne;
        var dx = Math.abs(node.i - end.i);
        var dy = Math.abs(node.j - end.j);
        var h = dx + dy; // * heightPenalty
        if (h === 0) {
            return 0; // At ending
        }
        h += node.tile1.pathfindPenalty;
        // TODO: precook this in the pathfind penalty
        if (node.crew.length > 0) {
            for (var iCrew = 0; iCrew < node.crew.length; iCrew++) {
                var crew = node.crew[iCrew];
                if (diveCrew_sidecar_1.diveCrew.isDeadish(crew)) {
                    h += deadCrewPathfindPenalty;
                }
                else {
                    h += crewPathfindPenalty;
                }
            }
        }
        return h;
    };
    var heuristicAny = function (node) {
        // Find minimum distance
        var hMin = Number.MAX_SAFE_INTEGER;
        for (var i = 0; i < ends.length; i++) {
            var end = ends[i];
            var dx = Math.abs(node.i - end.i);
            var dy = Math.abs(node.j - end.j);
            var h = dx + dy; // * heightPenalty
            if (h === 0) {
                return 0; // At ending
            }
            h += node.tile1.pathfindPenalty;
            // TODO: precook this in the pathfind penalty
            if (node.crew.length > 0) {
                for (var iCrew = 0; iCrew < node.crew.length; iCrew++) {
                    var crew = node.crew[iCrew];
                    if (diveCrew_sidecar_1.diveCrew.isDeadish(crew)) {
                        h += deadCrewPathfindPenalty;
                    }
                    else {
                        h += crewPathfindPenalty;
                    }
                }
            }
            if (h < hMin) {
                hMin = h;
            }
        }
        return hMin;
    };
    var collectNeighbors = function (node) {
        // TODO: do we need a function for walkable?
        if (!node.tile1.canWalk) {
            return []; // Can't move here
        }
        // left, right, up, down, traverse plane
        var neighbors = [];
        checkAndCollectNeighbor(node, -1, 0, neighbors);
        checkAndCollectNeighbor(node, 1, 0, neighbors);
        checkAndCollectNeighbor(node, 0, -1, neighbors);
        checkAndCollectNeighbor(node, 0, 1, neighbors);
        // TODO: teleporters?
        // if (node.tile1.type === EVoyageTile.Elevator) {
        //   let els = voyageTilemap.getElevators(node.text3)
        //   for (let i = 0; i < els.length; i++) {
        //     let el = els[i]
        //     if (el !== node) {
        //       neighbors.push(el)
        //     }
        //   }
        // }
        // TODO: if elevator
        // if (node.type === TypeLadder) {
        //   // Can go up on ladders
        //   checkNeighbor(0, -1)
        // }
        return neighbors;
    };
    var isEndOne = function (node) {
        // console.log('checking end isEndOne', node.i, node.j, endOne.i, endOne.j)
        return node === endOne;
        // return node.i === endOne.i && node.j === endOne.j
    };
    var isEndAny = function (node) {
        //console.log('checking ends m', ends.length)
        for (var i = 0; i < ends.length; i++) {
            var end = ends[i];
            // console.log('checking ends ' + i, node.i, node.j, end.i, end.j)
            if (end === node) {
                return true;
            }
            // if (node.i === end.i && node.j === end.j) {
            //   return true
            // }
        }
        return false;
    };
    // console.log(
    //   'looking for path',
    //   ends.length + ' ends !',
    //   start,
    //   isOne,
    //   ends,
    //   mode,
    // )
    // let t0 = performance.now()
    var result = astarInterface_sidecar_1.astarInterface.findPath({
        start: start,
        isEnd: isOne ? isEndOne : isEndAny,
        collectNeighbors: collectNeighbors,
        distance: distance,
        heuristic: isOne ? heuristicOne : heuristicAny,
        minimumH: 2,
        // hash,
        timeoutSteps: 5000,
    });
    if (!result.isSuccess) {
        result.path = []; // Clear path
    }
    // let t1 = performance.now()
    // let timeElapsed = t1 - t0
    // if (timeElapsed > 10 || result.status !== 'success') {
    //   console.log(
    //     'astar',
    //     'path result',
    //     result.status,
    //     result.path.length,
    //     timeElapsed.toFixed(1),
    //     'ms',
    //   )
    // }
    return result;
};
exports.findPathAny = findPathAny;
